// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"32f42498","201":"32f42498","531":"32f42498"}[chunkId] + ".chunk.css";
};